<template>
    <div class="d-flex justify-content-between align-items-center h-100 flex-column  w-100">
        <div v-if="ShowWarning" class="d-flex justify-content-center w-100">
            <b-alert class="w-50 text-center" show variant="danger">Leider ist bei der Anwesenheitsliste ein Fehler
                aufgetreten.
                Error:
                {{ error }}</b-alert>
        </div>
        <div v-if="isLoading" class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-else class="w-100 h-100 d-flex justify-content-center align-items-center">
            <div class="attendanceSheetLeft ml-1">
                <canvas ref="barChart"></canvas>
            </div>
            <div class="attendanceSheetRight">
                <canvas ref="pieChart"></canvas>
            </div>
        </div>
    </div>
</template>
<script>
import Chart from 'chart.js/auto';
import { nextTick } from 'vue';
import "moment-timezone/builds/moment-timezone-with-data-1970-2030";
import moment from "moment-timezone";

export default {
    name: "AttendanceSheetDiagram",
    props: [
        'laborAllocation', 'employee'
    ],
    data() {
        return {
            attendanceSheet: {},
            ShowWarning: false,
            error: null,
            present: [],
            absent: [],
            headOfLogistics: [],
            wareneingang: [],
            warenausgang: [],
            aushilfe: [],
            miniJobber: [],
            auszubildende: [],
            dropshipping: [],
            isLoading: true,
            pieChart: null,
            barChart: null,
            date: null,
        }
    },
    watch: {
        laborAllocation: {
            deep: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.handleData();

                }
            },
        },
        employee: {
            deep: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.handleData();
                }
            },
        },
    },
    methods: {
        async handleData() {
            const data = this.employee;
            Object.assign(this, {
                present: [],
                absent: [],
                headOfLogistics: [],
                wareneingang: [],
                warenausgang: [],
                aushilfe: [],
                miniJobber: [],
                auszubildende: [],
                dropshipping: []
            });

            const statusMap = {
                "Anwesend": this.present,
                "Abwesend": this.absent,
                "Krankgemeldet": this.absent,
                "Im Urlaub": this.absent
            };
            const areaMap = {
                "Head of Logistics": this.headOfLogistics,
                "Wareneingang": this.wareneingang,
                "Warenausgang": this.warenausgang,
                "Aushilfe": this.aushilfe,
                "MiniJobber": this.miniJobber,
                "Auszubildende": this.auszubildende,
                "Dropshipping": this.dropshipping
            };
            for await (const [index, item] of Object.entries(data || {})) {
                if (index === "") {
                    console.log("index:", index);
                }
                if (!item) continue;
                const { selectedStatus, selectedArea } = item;
                const statusTarget = statusMap[selectedStatus];
                if (statusTarget) {
                    statusTarget.push(item)
                }
                if (selectedStatus === "Anwesend") {
                    const areaTarget = areaMap[selectedArea];
                    if (areaTarget) {
                        areaTarget.push(item);
                    }
                }
            }
            this.isLoading = false;
            this.createBarChart();
            this.createPieCharts();
            return null;
        },
        createBarChart() {
            const headOfLogistics = ((this.headOfLogistics.length / Number(this.laborAllocation?.areaDistribution?.headOfLogistics)) * 100).toFixed(0);

            const wareneingang = ((this.wareneingang.length / Number(this.laborAllocation?.areaDistribution?.wareneingang)) * 100).toFixed(0);

            const warenausgang = ((this.warenausgang.length / Number(this.laborAllocation?.areaDistribution?.warenausgang)) * 100).toFixed(0);

            const aushilfe = ((this.aushilfe.length / Number(this.laborAllocation?.areaDistribution?.aushilfe)) * 100).toFixed(0);

            const miniJobber = ((this.miniJobber.length / Number(this.laborAllocation?.areaDistribution?.miniJobber)) * 100).toFixed(0);

            const auszubildende = ((this.auszubildende.length / Number(this.laborAllocation?.areaDistribution?.auszubildende)) * 100).toFixed(0);

            const dropshipping = ((this.dropshipping.length / Number(this.laborAllocation?.areaDistribution?.dropshipping)) * 100).toFixed(0);
            nextTick(() => {
                const chartId = this.$refs.barChart
                if (this.barChart) {
                    this.barChart.destroy()
                    this.barChart = null
                }
                this.barChart = new Chart(chartId, {
                    type: "bar",
                    data: {
                        labels: ["Head of Logistics", "Wareneingang", "Warenausgang", "Aushilfe", "MiniJobber", "Auszubildende", "Dropshipping"],
                        datasets: [{
                            data: [headOfLogistics, wareneingang, warenausgang, aushilfe, miniJobber, auszubildende, dropshipping],
                            backgroundColor: [
                                "#f16c49",
                                "#e8eb34",
                                "#ee4000",
                                "#34ebab",
                                "#344feb",
                                "#eb34e1",
                                "#1cc76f"
                            ],
                            borderColor: "#fff",
                            borderWidth: 3
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        indexAxis: "y",
                        scales: {
                            x: {
                                min: 0,
                                max: 100,
                                ticks: {
                                    font: {
                                        size: 25,
                                    },
                                    color: "#fff",
                                    stepSize: 10,
                                    callback: function (value) {
                                        return value + '%';
                                    }
                                },
                                beginAtZero: true
                            },
                            y: {
                                ticks: {
                                    font: {
                                        size: 35,
                                    },
                                    color: "#fff",
                                    padding: 20,
                                }
                            }
                        },
                        plugins: {
                            title: {
                                display: true,
                                text: "Anwesenden im Logistikbereich",
                                color: "#fff",
                                padding: {
                                    bottom: 30,
                                },
                                font: {
                                    size: 48
                                },
                            },
                            legend: {
                                display: false,
                            },
                        },
                    },
                })
            })
            return null;
        },
        createPieCharts() {
            const employeeTotal = ((this.absent.length) + (this.present.length));
            const absent = ((this.absent.length ? this.absent.length : 0) / employeeTotal * 100).toFixed(0);
            const present = ((this.present.length ? this.present.length : 0) / employeeTotal * 100).toFixed(0);
            const presentAmount = this.present.length ? this.present.length : 0;
            const absentAmount = this.absent.length ? this.absent.length : 0;
            nextTick(() => {
                const chartId = this.$refs.pieChart;
                if (this.pieChart) {
                    this.pieChart.destroy()
                    this.pieChart = null
                }
                this.pieChart = new Chart(chartId, {
                    type: "pie",
                    data: {
                        labels: ["Abwesend Anzahl: " + absentAmount + ", Prozentual: " + absent + "%",
                        "Anwesend Anzahl: " + presentAmount + ", Prozentual: " + present + "%"],
                        datasets: [{
                            backgroundColor: [
                                "#b91d47",
                                "#1e7145",
                            ],
                            data: [absent, present],
                        }],
                        padding: {
                            top: 30,
                            bottom: 30,
                        },
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        plugins: {
                            title: {
                                display: true,
                                text: "Gesamtanzahl der Anwesenden",
                                color: "#fff",
                                padding: {
                                    top: 30,
                                    bottom: 30,
                                },
                                font: {
                                    size: 48
                                },
                            },
                            legend: {
                                display: true,
                                position: "bottom",
                                labels: {
                                    padding: 30,
                                    color: '#fff',
                                    font: {
                                        size: 35
                                    },
                                },

                            },
                        },
                    },

                });
            });
            return null;
        }

    },
    async mounted() {
        this.handleData();
        setInterval(() => {
            this.date = moment(new Date()).locale('de').format('LL') + ', ' + moment(new Date()).locale('de').format('LTS');
        }, 1000);
    },

}
</script>
<style scoped>
.attendanceSheetLeft {
    width: 55%;
}

.attendanceSheetRight {
    width: 45%;
}

canvas {
    background-color: transparent !important;
}
</style>
